/* JUSTYOL — drop card countdown. Drives the little "⏳ 8j 23h 11m" chip on any
   product card for a drop product (favorites, collections, search, related).
   Bare local times are Morocco wall-clock → pinned to +01:00. Re-queries the DOM
   each tick so cards rendered later (e.g. the JS-built favorites grid) are picked
   up automatically. Flips to a "live" badge once the launch time passes. */
(function () {
  'use strict';

  function parse(raw) {
    raw = (raw || '').trim();
    if (!raw) return 0;
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw = raw.replace(' ', 'T') + '+01:00';
    var p = Date.parse(raw);
    return isNaN(p) ? 0 : p;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var now = Date.now();
    var nodes = document.querySelectorAll('[data-jy-drop-cd]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var ms = parse(el.getAttribute('data-jy-drop-cd'));
      var nums = el.querySelector('[data-cd-nums]');
      var live = el.querySelector('[data-cd-live]');
      if (!ms || now >= ms) {
        el.classList.add('is-live');
        if (nums) nums.hidden = true;
        if (live) live.hidden = false;
        continue;
      }
      var s = Math.max(0, Math.floor((ms - now) / 1000));
      var d = el.querySelector('[data-cd="d"]');
      var h = el.querySelector('[data-cd="h"]');
      var m = el.querySelector('[data-cd="m"]');
      if (d) d.textContent = pad(Math.floor(s / 86400));
      if (h) h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (m) m.textContent = pad(Math.floor((s % 3600) / 60));
    }
  }

  tick();
  setInterval(tick, 1000);
})();
